// extracted by mini-css-extract-plugin
export default {"title":"eUXiS","fullwidth_container":"jfUWa","container":"GOzIr","header":"uaDjd"};